<template>
  <div class="home relative">
    <div class="p-3 relative mx-auto text-gray-600">
      <input class="border hover:shadow bg-white h-10 px-5 pr-16 w-full rounded-lg text-sm focus:outline-none"
        type="search" name="search" placeholder="Search"
        v-model="searchText"
      >
      <button type="submit" class="absolute right-0 top-0 mt-6 mr-6">
        <svg class="text-gray-600 h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
          viewBox="0 0 56.966 56.966" style="enable-background:new 0 0 56.966 56.966;" xml:space="preserve"
          width="512px" height="512px">
          <path
            d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
        </svg>
      </button>
    </div>
    <div class="flex scroll-container mb-5" ref="scollContainer">
      <div class="w-screen" v-for="(item, index) in chunk(currentSelection)" :key="index" :id="index">
        <div class="flex flex-col w-screen scroll-item" :ref="`page${index}`" :tabindex="index">
            <CryptoCard
              v-for="cryptoCurrency in item"
              :key="cryptoCurrency.id"
              :id="cryptoCurrency.id"
              :name="cryptoCurrency.name"
              :symbol="cryptoCurrency.symbol"
              :price="cryptoCurrency.quote.USD.price"
              :dailyVolume="cryptoCurrency.quote.USD.volume_24h"
              :dailyChange="cryptoCurrency.quote.USD.percent_change_24h"
              :marketCap="cryptoCurrency.quote.USD.market_cap"
            />
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="fixed bottom-0 w-full bg-white flex justify-between p-3" v-if="currentSelection.length > 10">
        <div
          v-for="(item, index) in chunk(currentSelection)" :key="index"
          class="bg-gray-300 rounded-full w-3 h-3 cursor-pointer"
          :class="{ 'bg-green-400': currentPage === index }"
          @click="scrollIntoView(index)"
        />
      </div>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import CryptoCard from '@/components/CryptoCard.vue'
import chunk from 'lodash/chunk'

export default {
  name: "Home",
  components: {
    CryptoCard
  },
  data() {
    return {
      searchText: '',
      currentPage: 0,
      cryptocurrenyData: [],
    }
  },
  async created() {
    this.$firestore.collection('cryptocurrencies').orderBy('cmc_rank', 'asc').onSnapshot((querySnapshot) => {
      const cryptocurrencies = [];
      querySnapshot.forEach(function(doc) {
        cryptocurrencies.push(doc.data());
      })
      this.cryptocurrenyData = cryptocurrencies
    })
  },
  watch: {
    cryptocurrenyData(data) {
      if (data.length) {
        this.$nextTick(() => this.observePages())
      }
    }
  },
  computed: {
    currentSelection() {
      if (this.searchText.length) {
        return this.cryptocurrenyData.filter(cryptocurrency => cryptocurrency.name.toLowerCase().includes(this.searchText.toLowerCase()))
      }

      return this.cryptocurrenyData
    }
  },
  methods: {
    getLogo({ info }) {
      if (info && info.logo) {
        return info.logo
      }
      return ''
    },
    chunk(array) {
      return chunk(array, 10)
    },
    paginate(array, page_size, page_number) {
      // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
      return array.slice((page_number - 1) * page_size, page_number * page_size);
    },
    observePages() {
      Object.keys(this.$refs).forEach((ref) => {
        if (ref.startsWith('page')) {
          this.observeElement(this.$refs[ref][0])
        }
      })
    },
    observeElement(element) {
      const observer = new IntersectionObserver((entry) => {
        if (entry[0].intersectionRatio > 0.5) {
          this.currentPage = entry[0].target.tabIndex
        }
      }, {
        root: this.$refs.scollContainer, threshold:0.5
      });

      observer.observe(element)
    },
    scrollIntoView(index) {
      document.getElementById(index).scrollIntoView();
    }
  }
};
</script>

<style lang="scss" scoped>
.scroll-container {
  scroll-snap-type: x mandatory;
  overflow-x: scroll;
}

.scroll-item {
  scroll-snap-align: start
}

.list-complete-item {
  display: inline-block;
  margin-right: 10px;
  transition: all 1s;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
